export const CURRENT_ORGANIZATION_STORAGE_KEY = "bonni_current_organization_id";

type OrganizationReference = {
  id: string;
};

export function readCurrentOrganizationId(): string | null {
  if (typeof window === "undefined") return null;

  return window.localStorage.getItem(CURRENT_ORGANIZATION_STORAGE_KEY);
}

export function storeCurrentOrganizationId(organizationId: string): void {
  if (typeof window === "undefined") return;

  window.localStorage.setItem(CURRENT_ORGANIZATION_STORAGE_KEY, organizationId);
}

export function clearCurrentOrganizationId(): void {
  if (typeof window === "undefined") return;

  window.localStorage.removeItem(CURRENT_ORGANIZATION_STORAGE_KEY);
}

export function resolveCurrentOrganization<T extends OrganizationReference>(
  organizations: T[],
  storedOrganizationId: string | null,
): T | null {
  if (organizations.length === 0) return null;

  return (
    organizations.find((organization) => organization.id === storedOrganizationId) ||
    organizations[0]
  );
}

type OrganizationSelectionInput<T extends OrganizationReference> = {
  authLoading: boolean;
  organizationsLoading: boolean;
  userId: string | null;
  organizations: T[];
  storedOrganizationId: string | null;
};

export type OrganizationSelectionResolution<T extends OrganizationReference> =
  | { status: "wait" }
  | { status: "clear" }
  | { status: "select"; organization: T | null };

export function resolveOrganizationSelection<T extends OrganizationReference>({
  authLoading,
  organizationsLoading,
  userId,
  organizations,
  storedOrganizationId,
}: OrganizationSelectionInput<T>): OrganizationSelectionResolution<T> {
  if (authLoading || (userId && organizationsLoading)) {
    return { status: "wait" };
  }

  if (!userId) {
    return { status: "clear" };
  }

  return {
    status: "select",
    organization: resolveCurrentOrganization(organizations, storedOrganizationId),
  };
}
